<script>
    require('bootstrap');
    import Vue from 'vue'
    import router from './../../router'

    export default {
        template: `

    <div class="tab-content">
    <table class="table table-condensed">
    <thead>
    <th>{{ t('Seller') }}</th>
    <th>{{ t('Auction name') }}</th>
    <th>{{ t('Number of sales') }}</th>
    <th>{{ t('Price') }}</th>
</thead>
        <tbody>
        <tr v-for="row in rows">
            <td v-text="row.seller"></td>
            <td>
                <a :href="row.link">{{ row.name }}</a>
            </td>
            <td v-text="row.sale"></td>
            <td v-text="row.price"></td>

        </tr>
</tbody>
    </table>
            </div>`

        ,
        data() {
            return {
                rows:[]
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>
    .tab-content {
        background: #ffffff;
        padding: 20px;
    }

    table{
        width: 100%;
    }

    table th{
        font-weight: 900;
    }

    table td,table th{
        padding: 10px;
    }
</style>


// WEBPACK FOOTER //
// AllegroAnalysisDetail.vue?15025e67